import { useEffect } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { useAppDispatch } from "./store/hooks"
import { checkAuth } from "./store/sessionSlice"
import AppLayout from "./components/AppLayout"
import ProtectedRoute from "./components/ProtectedRoute"
import CourseReportPage from "./pages/CourseReportPage"
import EventReportPage from "./pages/EventReportPage"
import HomePage from "./pages/HomePage"
import LoginPage from "./pages/LoginPage"
import EventUserAttendanceSummaryPage from "./pages/EventUserAttendanceSummaryPage"
import LearningPathReportPage from "./pages/LearningPathReportPage"
import OrganizationReportPage from "./pages/OrganizationReportPage"
import UserEventAttendancePage from "./pages/UserEventAttendancePage"
import UserEventCreditTypePage from "./pages/UserEventCreditTypePage"
import UserEventRsvpStatusPage from "./pages/UserEventRsvpStatusPage"
import UserCoursePage from "./pages/UserCoursePage"
import UserLearningPathPage from "./pages/UserLearningPathPage"
import UserMandatedTrainingPage from "./pages/UserMandatedTrainingPage"
import UserReportPage from "./pages/UserReportPage"
import { OrgSettingsPage } from "./pages/org-settings/OrgSettingsPage"
import ApiDocsPage from "./pages/ApiDocsPage"

function App() {
  const dispatch = useAppDispatch()

  // Check authentication once on app mount
  useEffect(() => {
    dispatch(checkAuth())
  }, [dispatch])

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/reports/course" element={<CourseReportPage />} />
        <Route path="/reports/event" element={<EventReportPage />} />
        <Route
          path="/reports/learning-path"
          element={<LearningPathReportPage />}
        />
        <Route
          path="/reports/organization"
          element={<OrganizationReportPage />}
        />
        <Route path="/reports/user" element={<UserReportPage />} />
        <Route path="/reports/user-course" element={<UserCoursePage />} />
        <Route
          path="/reports/user-event-attendance"
          element={<UserEventAttendancePage />}
        />
        <Route
          path="/reports/user-event-rsvp-status"
          element={<UserEventRsvpStatusPage />}
        />
        <Route
          path="/reports/event-user-attendance-summary"
          element={<EventUserAttendanceSummaryPage />}
        />
        <Route
          path="/reports/user-learning-path"
          element={<UserLearningPathPage />}
        />
        <Route
          path="/reports/user-mandated-training"
          element={<UserMandatedTrainingPage />}
        />
        <Route
          path="/reports/user-event-credit-type"
          element={<UserEventCreditTypePage />}
        />
        <Route
          path="/reports"
          element={<Navigate to="/reports/user-event-credit-type" replace />}
        />
        <Route path="/settings" element={<OrgSettingsPage />} />
      </Route>

      {/* API Docs - protected but without sidebar */}
      <Route
        path="/api-docs"
        element={
          <ProtectedRoute>
            <ApiDocsPage />
          </ProtectedRoute>
        }
      />

      {/* Catch all - redirect to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
